import { gql } from "@apollo/client";

import { CreateImportMutation } from "src/graphql/import-export/__generated__/graphql.ts";
import { usePerformMutation } from "src/graphql/utils";

export const createImportMutation = gql(/* GraphQL */ `
  mutation CreateImport($fileId: String!, $importSpecificationId: String!) {
    import(fileId: $fileId, importSpecificationId: $importSpecificationId)
  }
`);

export const useCreateImportMutation = ({
  onSuccess,
}: {
  onSuccess: (data: CreateImportMutation | null | undefined) => void;
}) => {
  return usePerformMutation(createImportMutation, {
    onSuccess,
    mutationOption: {
      context: {
        uri: "/import-export-api/v1/private/graphql",
      },
    },
  });
};
